// Host yang boleh dilewatkan ke optimizer `next/image` — cermin daftar
// `remotePatterns` di `next.config.mjs`. Selain ini, StoreImage fallback ke
// <img> biasa. Anchored `$` di hostname mencegah spoofing lewat sufiks
// (mis. `supabase.co.evil.com` / `images.unsplash.com.evil.com`).
const OPTIMIZABLE_HOST = /(\.supabase\.co|(^|\.)images\.unsplash\.com)$/i;

/**
 * True bila `src` aman dioptimasi `next/image`: path lokal (`/...`) atau URL
 * https dengan host yang terdaftar di remotePatterns.
 *
 * URL dari host arbitrer (mis. gambar produk hasil import: `bdsingapore.com`,
 * CDN toko lain) → false. next/image MENOLAK host tak terdaftar dengan HTTP 400
 * → gambar rusak/tak tampil; StoreImage memakai hasil ini untuk fallback ke
 * <img> langsung agar gambar selalu muncul.
 */
export function canOptimizeImageHost(src: string | null | undefined): boolean {
  if (!src) return false;
  if (isSvgSource(src)) return false; // lihat catatan di isSvgSource
  if (src.startsWith("/")) return true; // aset lokal/statis Next
  try {
    const url = new URL(src);
    return url.protocol === "https:" && OPTIMIZABLE_HOST.test(url.hostname);
  } catch {
    return false; // URL tak valid → jangan paksa ke optimizer
  }
}

/**
 * True bila `src` menunjuk berkas SVG (ekstensi apa pun kapitalnya).
 *
 * `dangerouslyAllowSVG` MATI di `next.config.mjs`, dan bypass bawaan
 * next/image untuk SVG memeriksa `endsWith(".svg")` — **case-sensitive**.
 * Unggahan popup/hadiah mempertahankan huruf besar ekstensi asli (beda dari
 * branding yang meng-lowercase), jadi `PROMO.SVG` di host Supabase lolos ke
 * optimizer lalu ditolak HTTP 400 → gambar hilang total. Query string ikut
 * dibuang sebelum diperiksa (signed URL membawa `?token=`).
 */
export function isSvgSource(src: string): boolean {
  const path = src.split(/[?#]/)[0] ?? "";
  return path.toLowerCase().endsWith(".svg");
}
